module.exports = __webpack_public_path__ + "img/logo.e720b0d8.svg";